import React, { AriaAttributes } from 'react';

import ChevronRightIcon from '@/assets/icons/chevron-right.svg';
import LinkWrapper from '../link-wrapper/link-wrapper';
import Link from 'next/link';

interface BreadcrumbsProps {
  homeText: string;
  cssClass?: string;
  breadcrumbs: string[];
  node_locale: string;
  parent?: { name: string; slug: string };
}

export const Breadcrumbs = ({
  homeText,
  breadcrumbs,
  cssClass,
  node_locale,
  parent,
}: BreadcrumbsProps) => {
  const isCurrentPage = (index: number, arr: string[]) => {
    const t = arr.length === index + 1;
    const attr: AriaAttributes = { 'aria-current': 'page' };
    return t ? attr : {};
  };

  return (
    <nav
      className={`flex items-center pt-28 text-bodys font-bold text-text-default ${cssClass}`}
      aria-label="Breadcrumb"
      data-elastic-exclude
    >
      <ul
        className="inline-block"
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        <li
          className="inline-block "
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <LinkWrapper data={`/${node_locale.toLowerCase()}`} itemProp="item">
            <span itemProp="name">{homeText}</span>
            <meta itemProp="position" content="1" />
          </LinkWrapper>
        </li>
        {parent && (
          <li
            className="inline-block "
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            {/* Note: Do not use <LinkWrapper> here since pathprefix is already appended on parent.slug. */}
            <Link itemProp="item" href={parent.slug}>
              <ChevronRightIcon
                aria-label="Right arrow"
                viewBox="0 0 12 12"
                className="mx-2 inline h-2 w-2"
              />
              <span itemProp="name">{parent.name}</span>
              <meta itemProp="position" content="2" />
            </Link>
          </li>
        )}
        {breadcrumbs.map((crumb, index, arr) => (
          <li
            key={index}
            className="inline-block last:font-normal"
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <a
              href="#"
              {...isCurrentPage(index, arr)}
              itemProp="item"
              aria-current="page"
            >
              <ChevronRightIcon
                aria-label="Right arrow"
                viewBox="0 0 12 12"
                className="mx-2 inline h-2 w-2"
              />
              <span itemProp="name">{crumb}</span>
              <meta itemProp="position" content={parent ? '3' : '2'} />
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
